module.exports = __webpack_public_path__ + "static/bigPill-de3f264f4598066cd316dfa90cfc6c1d.png";